const vstore = {
	state: {
		someValue: 10,
		showCDK: true,
	},
	increment() {
		this.state.someValue++;
	},
	toggleShowCDK() {
		this.state.showCDK = !this.state.showCDK;
	},
};

export default vstore;
